<template>

  <header class="header">

    <button class="header__cta" @click="toggleModal(0)">
      <div class="header__cta-icon"></div>
      <div class="header__cta-label">Book</div>
    </button>

    <div class="header__content">
      <button class="header__nav header__nav--prev" @click="changeDate(`prev`)"></button>
      <h1 class="header__title">{{ this.monthName }} {{ date.year }}</h1>
      <button class="header__nav header__nav--next" @click="changeDate(`next`)"></button>
      <button class="header__link" @click="$emit(`scrollToToday`)">Today</button>
    </div>

  </header>

</template>

<script>
import moment from 'moment'

export default {
  name: 'Header',
  props: {
    date: Object,
    changeDate: Function,
    toggleModal: Function
  },
  computed: {
    monthName() {
      return moment(this.date.month, 'M').utcOffset(2).format('MMMM')
    }
  }
}
</script>

<style>
.header {
  height: 100px;
  z-index: 5;
  background-color: #111;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 640px) {

  .header {
    height: 60px;
  }

}

.header > * {
  margin: .5rem 2rem;
}

.header__content {
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

@media (max-width: 1024px) {

  .header__content {
    margin: 0 auto;
  }

}

.header__nav {
  width: 50px;
  height: 50px;
  outline: 0;
  border: 0;
  padding: 0;
  cursor: pointer;
  position: relative;
  background: none;
}

@media (min-width: 1025px) {

  .header__nav {
    opacity: .6;
  }

  .header__nav:hover {
    opacity: 1;
  }

}

.header__nav--prev {
  transform: rotate(180deg);
}

.header__nav:before,
.header__nav:after {
  content: '';
  left: 50%;
  top: 50%;
  width: 14px;
  height: 4px;
  border-radius: 2px;
  background-color: #fff;
  position: absolute;
}

.header__nav:before {
  top: 49%;
  transform-origin: 100% 0%;
  transform: translate(-50%, -50%) rotate(-45deg);
}

.header__nav:after {
  top: 51%;
  transform-origin: 100% 100%;
  transform: translate(-50%, -50%) rotate(45deg);
}

.header__title {
  margin: 0;
  width: 300px;
  font-size: 30px;
  line-height: 1;
  text-align: center;
}

@media (max-width: 640px) {

  .header__title {
    width: 160px;
    font-size: 18px;
  }

}

.header__cta {
  left: 15px;
  top: 50%;
  margin-top: -20px;
  height: 40px;
  padding: 0 15px;
  border-radius: 5px;
  z-index: 10;
  border: 0;
  outline: 0;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  position: absolute;
}

@media (min-width: 1025px) {

  .header__cta {
    opacity: .7;
  }

  .header__cta:hover {
    opacity: 1;
  }

}

@media (max-width: 1024px) {

  .header__cta {
    left: auto;
    top: auto;
    right: 15px;
    bottom: 15px;
    width: 42px;
    height: 42px;
    margin: 0;
    padding: 0;
    position: fixed;
    border-radius: 50%;
  }

}

.header__cta-label {
  font-size: 14px;
  font-weight: 700;
  margin-left: 10px;
  color: #111;
  display: block;
  text-transform: uppercase;
}

@media (max-width: 1024px) {

  .header__cta-label {
    display: none;
  }

}

.header__cta-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #111;
  position: relative;
}

@media (max-width: 1024px) {

  .header__cta-icon {
    width: 32px;
    height: 32px;
    background-color: transparent;
  }

}

.header__cta-icon:before,
.header__cta-icon:after {
  content: '';
  left: 50%;
  top: 50%;
  width: 50%;
  height: 2px;
  background-color: #fff;
  position: absolute;
  transform: translate(-50%, -50%);
}

@media (max-width: 1024px) {

  .header__cta-icon:before,
  .header__cta-icon:after {
    height: 4px;
    border-radius: 4px;
    background-color: #111;
  }

}

.header__cta-icon:after {
  transform: translate(-50%, -50%) rotate(-90deg);
}

.header__link {
  left: 50%;
  bottom: 5px;
  border: 0;
  padding: 5px;
  transform: translate(-50%, 0);
  opacity: .7;
  color: #fff;
  background: none;
  position: absolute;
  cursor: pointer;
}

.header__link:hover {
  opacity: 1;
  text-decoration: underline;
}

@media (max-width: 720px) {

  .header__link {
    display: none;
  }

}

</style>
